// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3OpXE","title":"AfterFrontImage_title__31O1O"};